import React, { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

export default function Apply() {
    const [form, setForm] = useState({ name: "", email: "", topic: "", bio: "", social_links: "" });
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/guest-applications", form);
            setSent(true);
            toast.success("Application sent. We'll be in touch.");
        } catch (err) {
            toast.error("Could not submit. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div data-testid="apply-page" className="px-6 md:px-12 lg:px-20 py-20 md:py-28 max-w-4xl mx-auto">
            <div className="eyebrow text-[#B8860B] mb-6">Collaborations</div>
            <h1 className="font-serif text-5xl md:text-6xl tracking-tight leading-[1.05] mb-6">
                Be a Guest on the Show.
            </h1>
            <p className="text-lg text-black/65 font-light max-w-2xl mb-14">
                We love stories about small, ordinary kindness. Whether you're a researcher, a neighbor, or someone who simply listens well — we'd love to hear from you.
            </p>

            {sent ? (
                <div data-testid="apply-success" className="bg-[#FAFAFA] border border-black/10 p-12 text-center">
                    <h2 className="font-serif text-3xl md:text-4xl mb-4">Thank you.</h2>
                    <p className="text-black/65 font-light">Your story is in our hands. We read every application and respond within two weeks.</p>
                </div>
            ) : (
                <form onSubmit={submit} className="grid md:grid-cols-2 gap-x-8 gap-y-10">
                    <Field label="Your Name" required value={form.name} onChange={update("name")} testid="apply-name" />
                    <Field label="Email" type="email" required value={form.email} onChange={update("email")} testid="apply-email" />
                    <div className="md:col-span-2">
                        <Field label="What do you want to talk about?" required value={form.topic} onChange={update("topic")} testid="apply-topic" />
                    </div>
                    <div className="md:col-span-2">
                        <label className="block eyebrow text-black/60 mb-3">Tell us about yourself *</label>
                        <textarea
                            required
                            rows={6}
                            value={form.bio}
                            onChange={update("bio")}
                            data-testid="apply-bio"
                            className="w-full border-b border-black/30 focus:border-[#D4AF37] outline-none py-3 bg-transparent font-light"
                        />
                    </div>
                    <div className="md:col-span-2">
                        <Field label="Social links (optional)" value={form.social_links} onChange={update("social_links")} testid="apply-social" />
                    </div>
                    <div className="md:col-span-2 pt-6">
                        <button
                            type="submit"
                            disabled={loading}
                            data-testid="apply-submit"
                            className="kind-btn-primary disabled:opacity-50"
                        >
                            {loading ? "Sending..." : "Send Application"} <ArrowRight size={16} />
                        </button>
                    </div>
                </form>
            )}
        </div>
    );
}

const Field = ({ label, type = "text", required, value, onChange, testid }) => (
    <div>
        <label className="block eyebrow text-black/60 mb-3">{label} {required && "*"}</label>
        <input
            type={type}
            required={required}
            value={value}
            onChange={onChange}
            data-testid={testid}
            className="w-full border-b border-black/30 focus:border-[#D4AF37] outline-none py-3 bg-transparent font-light"
        />
    </div>
);
